/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { useCartLocked } from 'Utils/ple-utils';
import { t } from 'Src/i18n';
import { FeatureCard } from 'Components/frameworks/feature-card/FeatureCard';
import { UpsellBooking } from 'Components/widgets/upsell-booking/UpsellBooking';
type Props = {
  bookingId?: string;
  className?: string;
  rental: RentalEntity;
  onBook?: (() => void) | null | undefined;
};
export const RentalCard = ({ bookingId, className, onBook, rental }: Props) => {
  const { isCartLocked } = useCartLocked(bookingId);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  if (!rental) {
    return null;
  }

  const { ageRestriction, furtherInformation, id, levels, longDescription, name, sizes } = rental;
  const list = [
    {
      label: t('common.age'),
      value: ageRestriction?.formatted || '',
    },
    {
      label: t('common.level'),
      value: (levels || []).map((l) => l.label).join(' - '),
    },
    {
      label: t('common.size'),
      value: sizes?.min
        ? `${[sizes?.min, sizes?.max].join(' - ')} ${(sizes?.unit || '').toLowerCase()}`
        : null,
    },
  ].filter((l) => l.value);
  return (
    <UpsellBooking onBook={onBook} upsell={rental}>
      {({ currentPrice, isAdded, isLoading, onExpand, onSubmit }) => (
        <div
          className="cursor-pointer"
          onClick={() => {
            setIsExpanded(!isExpanded);
            onExpand && onExpand(isExpanded);
          }}
        >
          <FeatureCard
            className={className}
            description={longDescription}
            hasReverseLayout
            isAdded={isAdded}
            isLoading={isLoading}
            isCartLocked={isCartLocked}
            id={id}
            list={list}
            name={name}
            note={furtherInformation}
            onBook={onSubmit}
            isExpanded={isExpanded}
            price={currentPrice}
          />
        </div>
      )}
    </UpsellBooking>
  );
};
